import { render } from "./IPLoader.vue?vue&type=template&id=097cc252"
import script from "./IPLoader.vue?vue&type=script&lang=js"
export * from "./IPLoader.vue?vue&type=script&lang=js"

import "./IPLoader.vue?vue&type=style&index=0&id=097cc252&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__